import { format } from 'date-fns';

const otpColorStyle = (val) => {
    if (val == null) return '';
    if (val >= 85) return 'color:#2e7d32;font-weight:bold';
    if (val >= 70) return 'color:#ed6c02;font-weight:bold';
    return 'color:#d32f2f;font-weight:bold';
};

const buildFlightSummaryHtml = (fs) => {
    if (!fs) return '';
    return `
        <div class="section">
            <div class="section-title">FLIGHT SUMMARY</div>
            <table class="kpi-table">
                <tr>
                    <td>Total Flights</td><td><strong>${fs.totalFlights ?? '-'}</strong></td>
                    <td>Cancelled</td><td style="${fs.cancelled > 0 ? 'color:#d32f2f;font-weight:bold' : ''}">${fs.cancelled ?? 0}</td>
                    <td>Diverted</td><td style="${fs.diverted > 0 ? 'color:#ed6c02;font-weight:bold' : ''}">${fs.diverted ?? 0}</td>                    
                    <td>Block Hrs</td><td><strong>${fs.totalBlockHours ?? '-'}</strong></td>
                </tr>
                <tr>
                    <td>Dep OTP</td><td><span style="${otpColorStyle(fs.depOTP)}">${fs.depOTP != null ? fs.depOTP + '%' : '-'}</span></td>
                    <td>Arr OTP</td><td><span style="${otpColorStyle(fs.arrOTP)}">${fs.arrOTP != null ? fs.arrOTP + '%' : '-'}</span></td>
                    <td>Avg Dep Delay</td><td>${fs.avgDelayDep != null ? fs.avgDelayDep + ' min' : '-'}</td>
                    <td>Avg Arr Delay</td><td>${fs.avgDelayArr != null ? fs.avgDelayArr + ' min' : '-'}</td>                    
                </tr>
            </table>
        </div>
    `;
};

const buildTodosHtml = (todos) => {
    if (!todos?.length) return '';
    const rows = todos.map((t, idx) => {
        const performer = t.performer?.lastName && t.performer?.firstName
            ? `${t.performer.lastName.toUpperCase()} ${t.performer.firstName.toUpperCase()}`
            : '-';
        const statusStyle = t.status === 'Completed'
            ? 'color:#2e7d32;font-weight:bold'
            : 'color:#ed6c02';
        return `<tr>
            <td>${idx + 1}</td>
            <td>${t.todo}</td>
            <td><span style="${statusStyle}">${t.status}</span></td>
            <td>${performer}</td>
        </tr>`;
    }).join('');

    return `
        <div class="section">
            <div class="section-title">TODOS CHECKLIST</div>
            <table>
                <thead>
                    <tr>
                        <th style="width:4%">#</th>
                        <th style="width:50%">Task</th>
                        <th style="width:18%">Status</th>
                        <th style="width:28%">Performer</th>
                    </tr>
                </thead>
                <tbody>${rows}</tbody>
            </table>
        </div>
    `;
};

const buildReadByHtml = (readBy) => {
    if (!readBy?.length) return '';
    const items = readBy.map(rb => {
        const name = rb.user?.lastName && rb.user?.firstName
            ? `${rb.user.lastName.toUpperCase()} ${rb.user.firstName.toUpperCase()}`
            : 'Unknown';
        const time = rb.readAt ? format(new Date(rb.readAt), 'HH:mm dd/MM/yy') : '';
        return `<span class="reader-tag">${name} <span class="reader-time">${time}</span></span>`;
    }).join(' ');

    return `
        <div class="section">
            <div class="section-title">READ BY (${readBy.length})</div>
            <div class="readers">${items}</div>
        </div>
    `;
};

const buildRecipientsHtml = (recipients) => {
    if (!recipients?.length) return '';
    const names = recipients.map(r =>
        `${r.lastName?.toUpperCase()} ${r.firstName?.toUpperCase()} (${r.email})`
    ).join(', ');
    return `<p style="margin:4px 0;font-size:10pt;color:#555"><strong>To:</strong> ${names}</p>`;
};

export const handlePrint = (report) => {
    const creatorName = report.creator
        ? `${report.creator.lastName?.toUpperCase()} ${report.creator.firstName?.toUpperCase()}`
        : 'Unknown';

    const reportDate = report.reportDate
        ? format(new Date(report.reportDate), 'dd/MM/yyyy')
        : '';
    const createdAt = report.createdAt
        ? format(new Date(report.createdAt), 'HH:mm dd/MM/yyyy')
        : '';

    const headerColor = report.shift?.color ?? '#3b82f6';

    const printWin = window.open('', '_blank', 'width=920,height=720');
    if (!printWin) return;

    printWin.document.write(`
<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8" />
    <title>${report.title || 'Shift Report'}</title>
    <style>
        @page { margin: 15mm 20mm; }
        * { box-sizing: border-box; }
        body { font-family: Arial, sans-serif; font-size: 10.5pt; color: #1a1a1a; margin: 0; }
        .header-band {
            background: ${headerColor};
            color: #fff;
            padding: 8px 14px;
            display: flex;
            align-items: center;
            gap: 10px;
            border-radius: 4px 4px 0 0;
        }
        .shift-badge {
            background: rgba(255,255,255,0.25);
            border: 1px solid rgba(255,255,255,0.5);
            border-radius: 12px;
            padding: 2px 10px;
            font-size: 9pt;
            font-weight: bold;
        }
        .header-title { font-size: 14pt; font-weight: bold; flex: 1; }
        .header-date  { font-size: 10pt; opacity: 0.9; }
        .meta { padding: 6px 14px; font-size: 9pt; color: #555; border-bottom: 1px solid #ddd; }
        .section { margin: 12px 14px 0; }
        .section-title {
            font-size: 8.5pt;
            font-weight: bold;
            color: #777;
            letter-spacing: 0.05em;
            text-transform: uppercase;
            margin-bottom: 6px;
            border-bottom: 1px solid #e0e0e0;
            padding-bottom: 3px;
        }
        .content { margin: 10px 14px; line-height: 1.5; }
        table { width: 100%; border-collapse: collapse; margin-top: 4px; }
        th, td { border: 1px solid #ccc; padding: 4px 7px; font-size: 9.5pt; }
        th { background: #f5f5f5; font-weight: bold; }
        .kpi-table td { border: none; padding: 3px 8px; }
        .kpi-table tr:nth-child(odd) { background: #fafafa; }
        .readers { display: flex; flex-wrap: wrap; gap: 8px; }
        .reader-tag {
            display: inline-block;
            background: #f0f0f0;
            border-radius: 4px;
            padding: 2px 8px;
            font-size: 9pt;
        }
        .reader-time { color: #888; font-size: 8.5pt; }
        @media print {
            body { font-size: 10pt; }
            @page { margin: 12mm 16mm; }
        }
    </style>
</head>
<body>
    <div class="header-band">
        <span class="shift-badge">${report.shift?.shiftName || report.shift?.shiftCode || 'Shift'}</span>
        <span class="header-title">${report.title || ''}</span>
        <span class="header-date">${reportDate}</span>
    </div>
    <div class="meta">
        By: <strong>${creatorName}</strong> &nbsp;|&nbsp; ${createdAt}
        ${buildRecipientsHtml(report.recipients)}
    </div>
    <div class="content">${report.content || ''}</div>
    ${buildFlightSummaryHtml(report.reportSummary)}
    ${buildTodosHtml(report.todos)}
    ${buildReadByHtml(report.readBy)}
</body>
</html>`);

    printWin.document.close();
    printWin.focus();
    setTimeout(() => {
        printWin.print();
        printWin.close();
    }, 300);
};
